const EXTENSIONS = {
  data: {
    url: `${process.env.REACT_APP_WEBSITE_URL}/backend/gridTranslate`,
    itemUrl: '',
    dataKey: 'extensions',
    onBeforeRequest: (config, request) => {
      if (!config.dataProps) return;
      if (request.type === 'loadView') {
        return {
          query: config.dataProps,
        };
      }
    },
  },
};

export default EXTENSIONS;
